import { render } from "./BoardReadMemberModal.vue?vue&type=template&id=0d06c115&scoped=true"
import script from "./BoardReadMemberModal.vue?vue&type=script&lang=js"
export * from "./BoardReadMemberModal.vue?vue&type=script&lang=js"

import "./BoardReadMemberModal.vue?vue&type=style&index=0&id=0d06c115&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d06c115"

export default script